<template>

    <div class="polaroid">
        <div class="image">
            <img :src="require(`../assets/images/${this.imgFile}`)" :alt="this.alt" />
            <div class="glare">
                <!-- <img :src="require(`../assets/images/${this.imgFile}`)" /> -->
            </div>
            <!-- <img :src="require(`../assets/images/${this.imgFile}`)" /> -->

        </div>
        <div class="bottom" v-if="this.caption">
            <p>{{ this.caption }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        imgFile: String,
        caption: String,
        alt: String,
    },
}
if (navigator.userAgent.indexOf('Chrome') > -1) {
    document.body.classList.add('chrome-browser');
}

</script>

<style scoped>
/* Polaroid Style */
.polaroid {
    /* style */
    background-color: rgb(240, 240, 255);
    border-radius: 5px;

    /* spacing */
    /* max-height: 100%; */
    /* width: 100%; */
    padding: 5%;
    /* margin: 25px 0px; */

    /* alignment */
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
}

/* image container */
.polaroid .image {
    width: fit-content;
    position: relative;
    border-radius: 5px;
    filter: grayscale(30%);
}

/* image */
.polaroid .image img {
    border-radius: 5px;
    max-width: 100%;
    height: 100%;
}

/* glare */
.polaroid .image .glare {
    /* placement */
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    /* style */
    border-radius: 5px;
    background: linear-gradient(217deg, rgba(205, 92, 92, 0.45), rgba(205, 0, 0, 0.05) 70.71%), linear-gradient(127deg, rgba(181, 205, 92, 0.4), rgba(0, 205, 0, 0.05) 70.71%), linear-gradient(336deg, rgba(92, 169, 205, 0.5), rgba(0, 0, 205, 0.05) 70.71%);
}

/* Script area */
.polaroid .bottom {
    padding-top: 15px;
    /* alsigntment */
    display: flex;
    align-items: center;
    justify-content: center;
    /* font */
    font-family: "besterReg";
    font-size: 2.2vw;
    font-weight: bold;
}

.polaroid .bottom p {
    white-space: nowrap;
}

/* hover interaction */
.polaroid:hover {
    filter: drop-shadow(0px 0px 15px rgb(50, 36, 56));
}

.polaroid:hover .image {
    filter: grayscale(0%);
}

.polaroid:hover .image .glare {
    background: linear-gradient(217deg, rgba(205, 92, 92, 0.2), rgba(205, 0, 0, 0) 70.71%), linear-gradient(127deg, rgba(181, 205, 92, 0.25), rgba(0, 205, 0, 0) 70.71%), linear-gradient(336deg, rgba(92, 169, 205, 0.3), rgba(0, 0, 205, 0) 70.71%);
}

/* SPECIALIZED HOVER INTERACTIONS */
/* removes script area for about page */
#aboutContent .glimpse .photoBox .polaroid .bottom {
    font-size: 2vw;
    display: none;
}

/* removes glare over project hver */
.project:hover .polaroid {
    filter: drop-shadow(0px 0px 15px rgb(50, 36, 56));
}

.project:hover .polaroid .image {
    filter: grayscale(0%);
}

.project:hover .polaroid .image .glare {
    background: linear-gradient(217deg, rgba(205, 92, 92, 0.2), rgba(205, 0, 0, 0) 70.71%), linear-gradient(127deg, rgba(181, 205, 92, 0.25), rgba(0, 205, 0, 0) 70.71%), linear-gradient(336deg, rgba(92, 169, 205, 0.3), rgba(0, 0, 205, 0) 70.71%);
}

/* small desktop */
@media only screen and (max-width: 1350px) {
    .polaroid .bottom {
        font-size: 2.4vw;
    }
}

/* Tablet */
@media only screen and (max-width: 915px) {
    .polaroid .bottom {
        font-size: 2.5vw;
    }
}

/* Mobile */
@media only screen and (max-width: 560px) {
    .polaroid .image {
        filter: grayscale(5%);
    }

    .polaroid .image .glare {
        background: linear-gradient(217deg, rgba(205, 92, 92, 0.35), rgba(205, 0, 0, 0.05) 70.71%), linear-gradient(127deg, rgba(181, 205, 92, 0.4), rgba(0, 205, 0, 0.05) 70.71%), linear-gradient(336deg, rgba(92, 169, 205, 0.5), rgba(0, 0, 205, 0.05) 70.71%);
    }

    .polaroid .bottom {
        font-size: 9vw;
    }
}

/* END Polaroid Style */

.chrome-browser .glare {
    /* Chrome-specific styles */
    margin-bottom: 3px;

}
</style>